export default __webpack_public_path__ + "static/media/Ficha Técnica - Polpa de Mamão Orgânico.b82d5938.pdf";